import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'NgxLibA-LibraryA',
  template: `
    <p>
      library-A works! Version 2
    </p>
  `,
  styles: []
})
export class LibraryAComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
